/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { FieldMappingDto } from './FieldMappingDto';
import {
    FieldMappingDtoFromJSON,
    FieldMappingDtoFromJSONTyped,
    FieldMappingDtoToJSON,
    FieldMappingDtoToJSONTyped,
} from './FieldMappingDto';

/**
 * 
 * @export
 * @interface LinkFieldsRequestDto
 */
export interface LinkFieldsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof LinkFieldsRequestDto
     */
    cuid: string;
    /**
     * 
     * @type {ImportType}
     * @memberof LinkFieldsRequestDto
     */
    importType?: ImportType;
    /**
     * 
     * @type {Array<FieldMappingDto>}
     * @memberof LinkFieldsRequestDto
     */
    mappings?: Array<FieldMappingDto> | null;
    /**
     * 
     * @type {string}
     * @memberof LinkFieldsRequestDto
     */
    defaultDateFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkFieldsRequestDto
     */
    joinKeyColumn?: string | null;
}



/**
 * Check if a given object implements the LinkFieldsRequestDto interface.
 */
export function instanceOfLinkFieldsRequestDto(value: object): value is LinkFieldsRequestDto {
    if (!('cuid' in value) || value['cuid'] === undefined) return false;
    return true;
}

export function LinkFieldsRequestDtoFromJSON(json: any): LinkFieldsRequestDto {
    return LinkFieldsRequestDtoFromJSONTyped(json, false);
}

export function LinkFieldsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkFieldsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cuid': json['cuid'],
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'mappings': json['mappings'] == null ? undefined : ((json['mappings'] as Array<any>).map(FieldMappingDtoFromJSON)),
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : json['defaultDateFormat'],
        'joinKeyColumn': json['joinKeyColumn'] == null ? undefined : json['joinKeyColumn'],
    };
}

export function LinkFieldsRequestDtoToJSON(json: any): LinkFieldsRequestDto {
    return LinkFieldsRequestDtoToJSONTyped(json, false);
}

export function LinkFieldsRequestDtoToJSONTyped(value?: LinkFieldsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cuid': value['cuid'],
        'importType': ImportTypeToJSON(value['importType']),
        'mappings': value['mappings'] == null ? undefined : ((value['mappings'] as Array<any>).map(FieldMappingDtoToJSON)),
        'defaultDateFormat': value['defaultDateFormat'],
        'joinKeyColumn': value['joinKeyColumn'],
    };
}

